import _ from 'lodash';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { useGetNavigationItems } from '../../../services/lwadmin/navigation/navigation-item-service';
import theme from '../../../../assets/stylesheets/_settings.global.scss';
import { Container, ContentContainer } from '../shared/styles';
import useNavigationStore from './state-hook';
import Header from './navigation-items-components/header';
import Item from './navigation-items-components/item';
import Preview from './navigation-items-components/preview';
import { DEFAULT_NAVIGATION_SLOT_ITEMS } from './navigation-slot-defaults';

export default function NavigationItems() {
  const set = useNavigationStore(state => state.set);
  const items = useNavigationStore(state => state.items);

  const [, getItems] = useGetNavigationItems();

  const onItemsData = React.useCallback(({ data }) => {
    const createdItems = _.get(data, 'items', []);
    const mergedItems = DEFAULT_NAVIGATION_SLOT_ITEMS.map(item => {
      const matchedItem = _.find(createdItems, { order: item.order });
      return matchedItem ? { ...item, ...matchedItem } : item;
    });

    set(state => {
      state.items = mergedItems;
    });
  }, [set]);

  useChangeAwareEffect(({ isMount }) => {
    if (!isMount) {
      return;
    }

    getItems().then(onItemsData);
  }, {});

  return (
    <ThemeProvider theme={theme}>
      <Container>
        <ContentContainer>
          <h1>Navigation</h1>
          <Header />
          {items.map(item => <Item key={item.order} item={item} />)}
          <Preview />
        </ContentContainer>
      </Container>
    </ThemeProvider>
  );
}
